import { ICourseComponent } from "../components/course-author/types";
import { DropZoneType } from "../context/UseDragAndDrop";

// Function to handle drag start event when dragging a child component
// But we need the drag image to be a parent component
export const onHandleChildDragStart = (
  data: ICourseComponent,
  parentSelector: string,
  type: DropZoneType,
  handleDragging: (b: boolean) => void,
  sourceTabId: number
) => (e: React.DragEvent<HTMLDivElement>) => {
  e.stopPropagation();
  e.dataTransfer.clearData();
  const parent = (e.target as HTMLElement).closest(`#${parentSelector}`);
  if (!parent) {
    return;
  }

  e.dataTransfer.setDragImage(parent, parent.clientWidth, 0);
  e.dataTransfer.setData("text/plain", JSON.stringify({ data, type, sourceTabId }));
  handleDragging(true);
};
